import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchGroupCodes(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/group_code/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchGroupCode(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/group_code/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addGroupCode(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/group_code', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }

  },
}
